import React from "react";
import {
  StyledBrandLogo,
  StyledLogoutButton,
  StyledNav,
  StyledNavItem,
  StyledNavLink,
  StyledTopAppBar,
  StyledTopAppBarWrapper,
  StyledPageTitle,
  StyledButton,
  StyledButtonList,
  StyledButtonItem,
} from "./styled";
import SearchBar from "../SearchBar";
import logout from "../../assets/icons/logout.svg";
import { useAuthStore } from "../../stores/authStore";
import { LinearProgress } from "@mui/material";
import { useContentStore } from "../../stores/contentStore";
import { locale } from "../../utils/LocaleManager";

const TopAppBar = (props: any) => {
  const setIsShowLogoutModal = useAuthStore(
    (state: any) => state.setIsShowLogoutModal,
  );
  const isLoading = useContentStore((state: any) => state.isLoading);

  const onLogout = async () => {
    setIsShowLogoutModal(true);
  };

  return (
    <StyledTopAppBar>
      <StyledTopAppBarWrapper>
        {props.isShowDetails ? (
          <>
            <StyledPageTitle>{props.pageTitle}</StyledPageTitle>
            <StyledButton
              onClick={props.onClose}
              style={{
                color: "#000",
                fontFamily: "Inter",
                fontSize: "1.25rem",
                fontStyle: "normal",
                fontWeight: "600",
                lineHeight: "normal",
                textTransform: "uppercase",
              }}
              disabled={props.isCancelDisabled}
            >
              {props.btnClose}
            </StyledButton>
          </>
        ) : props.isEditDetails ? (
          <>
            <StyledPageTitle>{props.pageTitle}</StyledPageTitle>
            <StyledButtonList>
              <StyledButtonItem>
                <StyledButton
                  onClick={props.onCancel}
                  background={"rgba(255, 255, 255, 0.20)"}
                  backgroundHovered={"rgba(255, 255, 255, 0.1)"}
                  style={{
                    color: "#fff",
                    fontFamily: "Inter",
                    fontSize: "1.25rem",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "normal",
                    textTransform: "uppercase",
                  }}
                  disabled={props.isCancelDisabled}
                >
                  {props.btnCancel}
                </StyledButton>
              </StyledButtonItem>
              <StyledButtonItem>
                <StyledButton
                  onClick={props.onSave}
                  style={{
                    color: "#000",
                    fontFamily: "Inter",
                    fontSize: "1.25rem",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "normal",
                    textTransform: "uppercase",
                  }}
                >
                  {props.btnSave}
                </StyledButton>
              </StyledButtonItem>
            </StyledButtonList>
          </>
        ) : (
          <>
            <StyledBrandLogo />
            {props.nav === "main" ? (
              <SearchBar />
            ) : (
              <div style={{ width: "35%" }}></div>
            )}
            <StyledNav>
              <StyledNavItem>
                <StyledNavLink isactive={(props.nav === "main").toString()} href="/main">
                  {locale.nav_browse}
                </StyledNavLink>
              </StyledNavItem>
              <StyledNavItem>
                <StyledNavLink isactive={(props.nav === "manage").toString()} href="/manage">
                  {locale.nav_manage}
                </StyledNavLink>
              </StyledNavItem>
            </StyledNav>
            <StyledLogoutButton onClick={() => onLogout()}>
              <img src={logout} alt="logout-icon" />
            </StyledLogoutButton>
          </>
        )}
      </StyledTopAppBarWrapper>
      {isLoading && <LinearProgress color="primary" />}
    </StyledTopAppBar>
  );
};

export default TopAppBar;
